import React from 'react';
export function ExploreIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.082 4.94A9.931 9.931 0 0012.016 2H12a10 10 0 00-.016 20H12a10 10 0 007.082-17.06zm-1.434 12.725A7.944 7.944 0 0112 20h-.013A8 8 0 1112 4h.012a8 8 0 015.636 13.665z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.142 7.546l-4.953 2.122a1 1 0 00-.525.525l-2.118 4.95a1 1 0 001.312 1.311l4.947-2.12a1 1 0 00.525-.525l2.124-4.95a1 1 0 00-1.312-1.313zm-2.493 5.108l-2.282.978.978-2.284 2.285-.979-.981 2.285z"
  }));
}